import ChapterItemComponent from "@common/chapters/ChapterItemComponent"
import FilledButtonM from "@common/components/button/FilledButtonM"
import { IconImageM } from "@common/components/icons/IconsM"
import TextM from "@common/components/text/TextM"
import SatisfactionComponent from "@common/liveMode/SatisfactionComponent"
import { theme } from "@common/theme/theme"
import { DimensionsContext } from "@common/utils/mobileUtils"
import { setOngoingActivity } from "@data/redux/actions/activity"
import { apiIdle, apiRequest } from "@data/redux/actions/api"
import { setIsLiveModeEnabled } from "@data/redux/actions/liveMode"
import { hasRole } from "@data/utility/ability"
import {
    capitalize,
    hoursMinutesAndSecondsFromSeconds,
    openCalendly,
} from "@data/utility/Utils"
import moment from "moment"
import React, { useContext, useState } from "react"
import { TouchableOpacity, View } from "react-native"
import { Divider } from "react-native-paper"
import { connect } from "react-redux"
import chronometer from "../../../../assets/icons/generic/chronometer.png"
import liveIcon from "../../../../assets/icons/generic/live.png"
import videoIcon from "../../../../assets/icons/generic/video.png"
import { ChampionImageM } from "../../../student/champions/ChampionImageM"

const engagementScores = {
    assiduity: {
        color: theme.colors.success,
        name: "Présence",
        total: 40,
    },
    interaction: {
        color: theme.colors.phone,
        name: "Participation",
        total: 30,
    },
    productivity: {
        color: theme.colors.purple,
        name: "Productivité",
        total: 30,
    },
}

const engagementBarHeight = 30

// Maps a parent "point d'attention" axis to its engagement sub-score key.
const PARENT_AXIS_TO_SCORE_KEY = {
    presence: "assiduity",
    participation: "interaction",
    productivite: "productivity",
}

// Above this total score, a parent session with no point d'attention is shown
// as "Séance bien engagée"; below it we stay silent rather than reassure on a
// mediocre-but-unflagged session.
const GOOD_SESSION_SCORE = 70

function LiveReportActivityItem(props) {
    const { data, report } = props
    const activityTemplate = report?.activity_templates?.find(
        (a) => a.id === data?.activity_template_id
    )

    return (
        <View
            style={{
                flexDirection: "row",
                alignItems: "center",
                marginTop: 10,
                alignSelf: "center",
            }}
        >
            <TextM fontSize={24} fontWeight={"ExtraBold"}>
                {data?.digit}
            </TextM>
            <IconImageM
                uri={activityTemplate?.icon}
                width={60}
                style={{ marginHorizontal: 10 }}
            />
            <TextM fontSize={17} fontWeight={"Bold"}>
                {data?.label}
            </TextM>
        </View>
    )
}

export const formatHoursMinutesAndSeconds = (
    duration,
    fontSize = 20,
    noSeconds = false
) => {
    const [hours, minutes, seconds] =
        hoursMinutesAndSecondsFromSeconds(duration)

    return (
        <>
            {hours > 0 && (
                <>
                    {hours}{" "}
                    <TextM fontSize={fontSize} fontWeight={"ExtraBold"}>
                        h
                    </TextM>{" "}
                </>
            )}
            {minutes}{" "}
            <TextM fontSize={fontSize} fontWeight={"ExtraBold"}>
                min
            </TextM>
            {!noSeconds && (
                <>
                    {" "}
                    {seconds}{" "}
                    <TextM fontSize={fontSize} fontWeight={"ExtraBold"}>
                        s
                    </TextM>
                </>
            )}
        </>
    )
}

function EngagementSubScoreBar({ scoreDetails, scoreKey, width }) {
    const totalWidth = width

    const elementWidth = scoreDetails?.score
        ? totalWidth * (scoreDetails?.score / 100)
        : 0

    return (
        <View
            style={{
                height: engagementBarHeight,
                backgroundColor: engagementScores[scoreKey]?.color,
                justifyContent: "center",
                alignItems: "center",
                width: elementWidth,
            }}
            disabled
            onPress={() => {}}
        />
    )
}

function EngagementSubScoreTitleComponent({
    scoreDetails,
    scoreKey,
    detailsVisible,
    alertSeverity = null,
    showDetailHint = false,
}) {
    const severityColor =
        alertSeverity === "alert"
            ? theme.colors.error
            : alertSeverity === "attention"
            ? theme.colors.warning
            : null
    return (
        <View>
            <View style={{ flexDirection: "row", alignItems: "center" }}>
                {!!severityColor && (
                    <View
                        style={{
                            width: 8,
                            height: 8,
                            borderRadius: 4,
                            backgroundColor: severityColor,
                            marginRight: 5,
                        }}
                    />
                )}
                <TextM
                    color={engagementScores[scoreKey]?.color}
                    fontWeight={"Bold"}
                    fontSize={14}
                >
                    {engagementScores?.[scoreKey]?.name?.toUpperCase()}{" "}
                    {scoreDetails?.score ?? "-"}{" "}
                    <TextM
                        fontSize={12}
                        fontWeight={"Medium"}
                        color={engagementScores[scoreKey]?.color}
                    >
                        /{scoreDetails?.score_max}
                    </TextM>{" "}
                </TextM>
            </View>
            {showDetailHint && (
                <TextM
                    fontSize={10}
                    fontWeight={"Medium"}
                    color={theme.colors.grey}
                    style={{ marginTop: 1 }}
                >
                    {detailsVisible ? "Masquer ▲" : "Détail ▼"}
                </TextM>
            )}
            {detailsVisible && (
                <View style={{ marginTop: 5 }}>
                    {scoreDetails?.details?.map((item, index) => {
                        return (
                            <View style={{ marginBottom: 5 }} key={index}>
                                <TextM
                                    fontWeight={"Medium"}
                                    color={engagementScores[scoreKey]?.color}
                                    fontSize={12}
                                >
                                    {/* Une ligne sans score (ex. « Travail
                                        oral — non évalué ») ne doit pas
                                        afficher un « /10 » vide au parent. */}
                                    {item?.name}{" "}
                                    {item?.score != null ? item.score : "—"}
                                    {item?.score != null ? (
                                        <TextM
                                            color={
                                                engagementScores[scoreKey]
                                                    ?.color
                                            }
                                            fontSize={10}
                                        >
                                            {" "}/{item?.score_max}
                                        </TextM>
                                    ) : null}
                                </TextM>
                                <TextM fontWeight={"Thin"} fontSize={10}>
                                    {item?.value} {item?.unity}
                                </TextM>
                            </View>
                        )
                    })}
                </View>
            )}
        </View>
    )
}

function EngagementSubScoreTitle({
    scoreDetails,
    scoreKey,
    detailsVisible,
    setDetailsVisible,
    disableScoreButton = false,
    alertSeverity = null,
    showDetailHint = false,
}) {
    return !disableScoreButton ? (
        <TouchableOpacity
            style={{
                justifyContent: "flex-start",
                alignItems: "flex-start",
                borderRadius: 5,
                paddingHorizontal: 10,
                paddingVertical: detailsVisible ? 5 : 2,
            }}
            onPress={() => {
                setDetailsVisible(!detailsVisible)
            }}
        >
            <EngagementSubScoreTitleComponent
                scoreDetails={scoreDetails}
                scoreKey={scoreKey}
                detailsVisible={detailsVisible}
                alertSeverity={alertSeverity}
                showDetailHint={showDetailHint}
            />
        </TouchableOpacity>
    ) : (
        <View
            style={{
                justifyContent: "flex-start",
                alignItems: "flex-start",
                borderRadius: 5,
                paddingHorizontal: 10,
                paddingVertical: detailsVisible ? 5 : 2,
            }}
        >
            <EngagementSubScoreTitleComponent
                scoreDetails={scoreDetails}
                scoreKey={scoreKey}
                detailsVisible={detailsVisible}
                alertSeverity={alertSeverity}
                showDetailHint={showDetailHint}
            />
        </View>
    )
}

export function EngagementScoreBar({
    scores,
    forceVerticalDetails = false,
    width,
    noProgressBar = false,
    disableScoreButton = false,
    style,
    alertSeverityByScoreKey = {},
    showDetailHint = false,
}) {
    const [detailsVisible, setDetailsVisible] = useState(false)
    const dimensions = useContext(DimensionsContext)

    return (
        <>
            <View
                style={{
                    flexDirection:
                        dimensions?.width < 800 || forceVerticalDetails
                            ? "column"
                            : "row",
                    width,
                    alignItems: forceVerticalDetails ? "center" : null,
                    marginTop: noProgressBar ? 0 : 30,
                    paddingHorizontal: 10,
                    paddingBottom: noProgressBar ? 0 : 5,
                    marginLeft: 10,
                    ...style,
                }}
            >
                {Object.keys(engagementScores).map((key) => {
                    return (
                        <EngagementSubScoreTitle
                            key={key}
                            scoreKey={key}
                            width={width}
                            scoreDetails={scores?.[key]}
                            detailsVisible={detailsVisible}
                            setDetailsVisible={setDetailsVisible}
                            disableScoreButton={disableScoreButton}
                            alertSeverity={alertSeverityByScoreKey?.[key]}
                            showDetailHint={showDetailHint}
                        />
                    )
                })}
            </View>
            {!noProgressBar && (
                <View
                    style={{
                        flexDirection: "row",
                        height: engagementBarHeight,
                        backgroundColor: theme.colors.whiteAlmost,
                        width,
                        justifyContent: "flex-start",
                    }}
                >
                    {Object.keys(engagementScores).map((key) => {
                        return (
                            <EngagementSubScoreBar
                                key={key}
                                scoreKey={key}
                                width={width}
                                scoreDetails={scores?.[key]}
                            />
                        )
                    })}
                </View>
            )}
        </>
    )
}

/**
 * The curated "points d'attention" surfaced on top of the engagement card
 * (red = alerte, orange = point d'attention), shown to both the parent and the
 * student. Each line is one factual signal already computed for the tutor
 * closure; recurrence adds a "Nᵉ séance consécutive" badge. Tapping a line
 * reveals a precision + action. Backend builder: ParentEngagementAlertsService.
 */
function ParentEngagementAlertRow({ alert }) {
    const [open, setOpen] = useState(false)
    const isAlert = alert?.severity === "alert"
    const hasDetail = !!alert?.detail

    const rowStyle = {
        backgroundColor: isAlert
            ? theme.colors.errorLight
            : theme.colors.warningLight,
        borderRadius: 10,
        padding: 10,
        marginBottom: 6,
    }

    const body = (
        <>
            <View style={{ flexDirection: "row", alignItems: "center" }}>
                <View
                    style={{
                        width: 18,
                        height: 18,
                        borderRadius: 9,
                        backgroundColor: isAlert
                            ? theme.colors.error
                            : theme.colors.warning,
                        alignItems: "center",
                        justifyContent: "center",
                        marginRight: 8,
                    }}
                >
                    <TextM
                        fontSize={11}
                        fontWeight={"Bold"}
                        color={theme.colors.white}
                    >
                        !
                    </TextM>
                </View>
                <TextM
                    fontSize={13}
                    fontWeight={"Medium"}
                    style={{ flex: 1 }}
                    wrap
                >
                    {alert?.message}
                    {!!alert?.recurrence_count && (
                        <TextM
                            fontSize={11}
                            fontWeight={"Bold"}
                            color={theme.colors.error}
                        >
                            {"  · "}
                            {alert.recurrence_count}
                            {"ᵉ séance consécutive"}
                        </TextM>
                    )}
                </TextM>
                {hasDetail && (
                    <TextM
                        fontSize={12}
                        color={theme.colors.grey}
                        style={{ marginLeft: 6 }}
                    >
                        {open ? "▲" : "▼"}
                    </TextM>
                )}
            </View>
            {open && hasDetail && (
                <TextM
                    fontSize={12}
                    fontWeight={"Medium"}
                    color={theme.colors.grey}
                    wrap
                    style={{
                        marginTop: 8,
                        marginLeft: 26,
                        paddingTop: 8,
                        borderTopWidth: 1,
                        borderTopColor: "rgba(0,0,0,0.07)",
                        lineHeight: 18,
                    }}
                >
                    {alert.detail}
                </TextM>
            )}
        </>
    )

    if (!hasDetail) {
        return <View style={rowStyle}>{body}</View>
    }
    return (
        <TouchableOpacity
            activeOpacity={0.7}
            onPress={() => setOpen(!open)}
            style={rowStyle}
        >
            {body}
        </TouchableOpacity>
    )
}

function ParentEngagementAlerts({ alerts }) {
    if (!alerts?.length) return null
    return (
        <View style={{ alignSelf: "stretch", marginTop: 16 }}>
            <TextM
                fontWeight={"Bold"}
                fontSize={12}
                color={theme.colors.grey}
                style={{ marginBottom: 8 }}
            >
                ⚠️ POINTS D'ATTENTION
            </TextM>
            {alerts.map((alert, index) => (
                <ParentEngagementAlertRow key={index} alert={alert} />
            ))}
        </View>
    )
}

/**
 * Shown in place of the points d'attention when the session went well, so a
 * good live reads as reassuring without overstating it (parent + student).
 */
function ParentEngagementOk() {
    return (
        <View
            style={{
                alignSelf: "stretch",
                marginTop: 16,
                flexDirection: "row",
                alignItems: "center",
                justifyContent: "center",
                backgroundColor: theme.colors.successLight,
                borderRadius: 10,
                padding: 12,
            }}
        >
            <View
                style={{
                    width: 10,
                    height: 10,
                    borderRadius: 5,
                    backgroundColor: theme.colors.success,
                    marginRight: 8,
                }}
            />
            <TextM
                fontSize={13}
                fontWeight={"Bold"}
                color={theme.colors.success}
            >
                Séance bien engagée
            </TextM>
        </View>
    )
}

/**
 * Helper to get urgency color for assessment badge
 */
function getUrgencyColor(urgency) {
    switch (urgency) {
        case "critical":
            return theme.colors.error
        case "high":
            return theme.colors.warning
        case "medium":
            return theme.colors.accent
        default:
            return theme.colors.info
    }
}

/**
 * Groups chapters by linked assessments and orphans
 */
function useChapterGroups(chapters, linkedAssessments) {
    // Build lookup: chapter_id -> assessment
    const chapterToAssessment = {}
    const assessmentGroups = {}

    if (linkedAssessments?.length > 0) {
        linkedAssessments.forEach((assessment) => {
            assessmentGroups[assessment.id] = {
                assessment,
                chapters: [],
            }
            assessment.matched_chapter_ids?.forEach((chapterId) => {
                chapterToAssessment[chapterId] = assessment.id
            })
        })
    }

    // Separate chapters into groups
    const orphanChapters = []

    chapters?.forEach((item) => {
        const chapterInfos = {
            ...item,
            ...item?.chapter,
        }
        const chapterId = chapterInfos?.chapter_id || chapterInfos?.id

        if (chapterToAssessment[chapterId]) {
            const assessmentId = chapterToAssessment[chapterId]
            assessmentGroups[assessmentId].chapters.push(chapterInfos)
        } else {
            orphanChapters.push(chapterInfos)
        }
    })

    // Get sorted assessment groups (by date, soonest first)
    const sortedGroups = Object.values(assessmentGroups)
        .filter((group) => group.chapters.length > 0)
        .sort((a, b) => a.assessment.days_until - b.assessment.days_until)

    return { sortedGroups, orphanChapters }
}

/**
 * Renders all chapter widgets - one per assessment + one for orphans
 */
function ChaptersWidgets({
    chapters,
    linkedAssessments,
    dimensions,
    boxStyle,
}) {
    const { sortedGroups, orphanChapters } = useChapterGroups(
        chapters,
        linkedAssessments
    )

    return (
        <>
            {/* One widget per assessment */}
            {sortedGroups.map((group) => (
                <AssessmentChaptersWidget
                    key={group.assessment.id}
                    group={group}
                    dimensions={dimensions}
                    boxStyle={boxStyle}
                />
            ))}

            {/* Orphan chapters widget */}
            {orphanChapters.length > 0 && (
                <View style={boxStyle}>
                    <TextM
                        fontSize={18}
                        fontWeight="Bold"
                        style={{ textAlign: "center", marginBottom: 10 }}
                        wrap
                    >
                        {sortedGroups.length > 0
                            ? "AUTRES CHAPITRES"
                            : "AVANCEMENT DES CHAPITRES"}
                    </TextM>
                    {orphanChapters.map((chapterInfos, index) => (
                        <ChapterItemComponent
                            chapter={chapterInfos}
                            key={`orphan-${index}`}
                            liveReportMode
                            validatedActivities={
                                chapterInfos?.validated_activities_count
                            }
                            todoActivities={chapterInfos?.todo_activities_count}
                        />
                    ))}
                </View>
            )}
        </>
    )
}

/**
 * Widget for a single assessment's chapter progress
 */
function AssessmentChaptersWidget({ group, boxStyle }) {
    const { assessment, chapters } = group
    const dateFormatted = moment(assessment.date).format("ddd D MMM")
    const urgencyColor = getUrgencyColor(assessment.urgency)
    const progress = assessment.preparation_progress || 0
    const subjectColor =
        assessment.school_subject?.color || theme.colors.primary

    return (
        <View
            style={{
                borderWidth: boxStyle.borderWidth,
                borderColor: boxStyle.borderColor,
                borderRadius: boxStyle.borderRadius || theme.roundness,
                backgroundColor: theme.colors.white,
                marginTop: boxStyle.marginTop,
                width: boxStyle.width,
                overflow: "hidden",
            }}
        >
            {/* Compact colored header */}
            <View
                style={{
                    backgroundColor: subjectColor,
                    paddingVertical: 12,
                    paddingHorizontal: 15,
                    flexDirection: "row",
                    alignItems: "center",
                }}
            >
                <View style={{ flex: 1 }}>
                    <TextM
                        fontSize={10}
                        fontWeight="Bold"
                        color={theme.colors.white}
                        style={{ opacity: 0.85, letterSpacing: 0.5 }}
                    >
                        PRÉPARATION DU CONTRÔLE
                    </TextM>
                    <TextM
                        fontSize={15}
                        fontWeight="Bold"
                        color={theme.colors.white}
                    >
                        {assessment.school_subject?.name} · {dateFormatted}
                    </TextM>
                </View>
                <View
                    style={{
                        backgroundColor: theme.colors.white,
                        borderRadius: 14,
                        paddingHorizontal: 10,
                        paddingVertical: 4,
                    }}
                >
                    <TextM
                        fontSize={13}
                        fontWeight="ExtraBold"
                        color={urgencyColor}
                    >
                        J-{assessment.days_until}
                    </TextM>
                </View>
            </View>

            {/* Progress bar */}
            <View
                style={{
                    paddingHorizontal: 15,
                    paddingVertical: 10,
                }}
            >
                <View
                    style={{
                        flexDirection: "row",
                        alignItems: "center",
                    }}
                >
                    <View
                        style={{
                            flex: 1,
                            height: 6,
                            backgroundColor: theme.colors.lightMore,
                            borderRadius: 3,
                            overflow: "hidden",
                        }}
                    >
                        <View
                            style={{
                                width: `${Math.min(100, progress)}%`,
                                height: "100%",
                                backgroundColor: subjectColor,
                                borderRadius: 3,
                            }}
                        />
                    </View>
                    <TextM
                        fontSize={13}
                        fontWeight="Bold"
                        color={subjectColor}
                        style={{ marginLeft: 10, minWidth: 38 }}
                    >
                        {progress}%
                    </TextM>
                </View>
            </View>

            {/* Chapters list */}
            <View style={{ paddingHorizontal: 10, paddingBottom: 10 }}>
                {chapters.map((chapterInfos, index) => (
                    <ChapterItemComponent
                        chapter={chapterInfos}
                        key={`${assessment.id}-${index}`}
                        liveReportMode
                        validatedActivities={
                            chapterInfos?.validated_activities_count
                        }
                        todoActivities={chapterInfos?.todo_activities_count}
                    />
                ))}
            </View>
        </View>
    )
}

const LiveReportComponent = (props) => {
    const {
        liveReport,
        withTitle = false,
        style,
        forceVerticalDetails = false,
        noDate = false,
        noScore = false,
    } = props
    const report = liveReport

    // Same report for the parent and the student (the student sees it at the
    // end of their live): surface the curated "points d'attention" on the
    // engagement card and drop the auto-positive Zoé message. Gated on a real,
    // loaded non-trial session (is_trial === false, i.e. the occurrence is
    // loaded and it isn't a trial) — trials keep the Zoé message (their
    // report's job is conversion) and show no points d'attention.
    const isEngagementReport = report?.is_trial === false
    const engagementAlerts = isEngagementReport
        ? report?.engagement_alerts ?? []
        : []
    const alertSeverityByScoreKey = {}
    engagementAlerts.forEach((alert) => {
        const scoreKey = PARENT_AXIS_TO_SCORE_KEY[alert?.axis]
        if (!scoreKey) return
        // Worst severity wins per axis: a red signal dominates an orange one.
        if (alertSeverityByScoreKey[scoreKey] !== "alert") {
            alertSeverityByScoreKey[scoreKey] = alert?.severity
        }
    })
    const engagementTotalScore = report?.statistics?.scores?.total_score
    const showEngagementOk =
        isEngagementReport &&
        engagementAlerts.length === 0 &&
        typeof engagementTotalScore === "number" &&
        engagementTotalScore >= GOOD_SESSION_SCORE
    const schoolSubjects = report?.school_subjects
    const sessionDate = capitalize(
        moment(report?.statistics?.live_date_time).format("dddd DD MMMM HH:mm")
    )
    const validatedActivities = report?.statistics?.validated_activities
    const todoActivities = report?.statistics?.todo_activities
    const chapters = report?.statistics?.ongoing_student_chapters

    const dimensions = useContext(DimensionsContext)
    // Inner width of the engagement card content (score bar + parent alerts).
    const scoreCardContentWidth = style?.width
        ? style?.width - 60
        : dimensions?.width - 60

    const isV1Report =
        report && !!report?.statistics
            ? !("ongoing_student_chapters" in report.statistics)
            : false

    // Get commented report content (already parsed by backend)
    const commentedReportContent = report?.commented_report?.content || null

    // Check if commentedReportContent has actual content
    const hasCommentedReportContent =
        commentedReportContent &&
        (Array.isArray(commentedReportContent)
            ? commentedReportContent.length > 0
            : Object.keys(commentedReportContent).length > 0)

    const commentedReportKeys = [
        "strengths",
        "challenges",
        "progress",
        "next_goal",
    ]

    const boxStyle = {
        borderWidth: 2,
        borderColor: theme.colors.lightMore,
        borderRadius: theme.roundness,
        padding: 20,
        backgroundColor: theme.colors.white,
        marginTop: 20,
        width: dimensions?.width - 60,
        justifyContent: "center",
        alignItems: "center",
    }

    return (
        <>
            <View
                style={{
                    borderWidth: 1,
                    borderColor: theme.colors.lightMore,
                    borderRadius: 10,
                    width: dimensions?.width - 20,
                    padding: 20,
                    backgroundColor: theme.colors.white,
                    marginTop: 30,
                    marginBottom: 20,
                    justifyContent: "center",
                    alignItems: "center",
                    alignSelf: "center",
                    ...style,
                }}
            >
                {withTitle && (
                    <TextM
                        color={theme.colors.primary}
                        fontSize={20}
                        fontWeight={"ExtraBold"}
                        style={{ textAlign: "center" }}
                        wrap
                    >
                        RAPPORT DE LIVE
                    </TextM>
                )}
                {!noDate && (
                    <TextM
                        color={theme.colors.primary}
                        fontSize={20}
                        fontWeight={"ExtraBold"}
                        style={{ textAlign: "center" }}
                        wrap
                    >
                        {sessionDate}
                    </TextM>
                )}
                <TextM wrap style={{ textAlign: "center" }}>
                    {report?.student?.display_name}
                </TextM>
                <ChampionImageM
                    style={{ alignSelf: "center", marginVertical: 20 }}
                    name="zoe"
                    variant={
                        report?.statistics?.zoe_variant
                            ? report?.statistics?.zoe_variant
                            : !report?.statistics
                            ? "main"
                            : "happy"
                    }
                    width={100}
                />
                {(!report?.statistics || !isEngagementReport) && (
                    <TextM
                        color={theme.colors.primary}
                        fontSize={18}
                        fontWeight={"Bold"}
                        style={{
                            textAlign: "center",
                            marginBottom: 10,
                            marginHorizontal: 20,
                        }}
                        wrap
                    >
                        {!report?.statistics
                            ? "Malheureusement, nous n’avons pas eu la chance de te voir aujourd’hui. Quel dommage..."
                            : report?.statistics?.CTAS?.zoe}
                    </TextM>
                )}
                {!!report?.statistics?.CTAS?.sam && (
                    <FilledButtonM
                        label={"Je prends rdv avec mon conseiller"}
                        color={theme.colors.success}
                        style={{
                            width: dimensions.width - 60,
                            alignSelf: "center",
                            marginTop: 15,
                            marginBottom: 15,
                        }}
                        onPress={() => openCalendly(report?.student)}
                    />
                )}

                {hasCommentedReportContent && (
                    <View
                        style={{
                            ...boxStyle,
                        }}
                    >
                        <TextM
                            fontSize={18}
                            fontWeight={"Bold"}
                            style={{ textAlign: "center", marginBottom: 15 }}
                            wrap
                        >
                            BILAN DE LA SESSION
                        </TextM>

                        <View
                            style={{
                                width: "100%",
                                paddingLeft: 10,
                            }}
                        >
                            {commentedReportKeys?.map((key) => {
                                const value = commentedReportContent[key]
                                if (!value) return null

                                return (
                                    <View
                                        key={key}
                                        style={{
                                            flexDirection: "row",
                                            alignItems: "flex-start",
                                        }}
                                    >
                                        <TextM
                                            fontSize={20}
                                            fontWeight={"Bold"}
                                            style={{
                                                marginRight: 5,
                                                marginTop: -2,
                                            }}
                                        >
                                            •
                                        </TextM>
                                        <TextM
                                            fontSize={14}
                                            fontWeight={"Regular"}
                                            style={{
                                                flex: 1,
                                                lineHeight: 20,
                                            }}
                                            wrap
                                        >
                                            {value}
                                        </TextM>
                                    </View>
                                )
                            })}
                        </View>

                        {/* <DebugSection report={report} /> */}
                    </View>
                )}

                {!!report?.statistics?.CTAS?.sam &&
                    report?.satisfaction &&
                    report?.satisfaction >= 5 && (
                        <View
                            style={{
                                ...boxStyle,
                            }}
                        >
                            <TextM
                                fontSize={18}
                                fontWeight={"Bold"}
                                style={{ textAlign: "center" }}
                                color={theme.colors.primary}
                                wrap
                            >
                                Qu&apos;a pensé{" "}
                                {report?.student?.display_name?.substring(
                                    0,
                                    report?.student?.display_name?.length - 3
                                )}{" "}
                                de cette session LIVE ?
                            </TextM>
                            <SatisfactionComponent
                                rating={report?.satisfaction}
                                readonly
                            />
                        </View>
                    )}

                {validatedActivities?.length + todoActivities?.length > 0 &&
                    isV1Report &&
                    !!report?.statistics && (
                        <View
                            style={{
                                ...boxStyle,
                            }}
                        >
                            <TextM fontSize={18} fontWeight={"Bold"}>
                                NOTIONS ABORDÉES
                            </TextM>
                            <View
                                style={{
                                    width: "100%",
                                }}
                            >
                                {report?.statistics?.concepts?.map(
                                    (c, index) => {
                                        const schoolSubject =
                                            schoolSubjects?.find(
                                                (s) =>
                                                    s.id === c.school_subject_id
                                            )
                                        return (
                                            <View
                                                style={{
                                                    flexDirection: "row",
                                                    marginTop: 20,
                                                    width: "100%",
                                                }}
                                                key={index}
                                            >
                                                <IconImageM
                                                    uri={schoolSubject?.icon}
                                                    style={{
                                                        marginRight: 10,
                                                    }}
                                                    width={60}
                                                />
                                                <View style={{ flex: 1 }}>
                                                    <TextM
                                                        fontWeight={"Bold"}
                                                        fontSize={17}
                                                    >
                                                        {schoolSubject?.name}
                                                    </TextM>
                                                    <TextM fontSize={17} wrap>
                                                        {c?.concepts?.join(
                                                            ", "
                                                        )}
                                                    </TextM>
                                                </View>
                                            </View>
                                        )
                                    }
                                )}
                            </View>
                        </View>
                    )}

                {!isV1Report && !!report?.statistics && !noScore && (
                    <>
                        <View
                            style={{
                                ...boxStyle,
                                paddingBottom: 0,
                                overflow: "hidden",
                            }}
                        >
                            <TextM
                                fontSize={18}
                                fontWeight={"Bold"}
                                style={{ textAlign: "center" }}
                                wrap
                            >
                                SCORE D&apos;ENGAGEMENT SUR LA SESSION
                            </TextM>
                            <View
                                style={{
                                    flexDirection: "row",
                                    alignItems: "center",
                                    marginTop: 10,
                                }}
                            >
                                <TextM fontSize={30} fontWeight={"ExtraBold"}>
                                    {report?.statistics?.scores?.total_score}{" "}
                                    <TextM fontSize={20} fontWeight={"Bold"}>
                                        /100
                                    </TextM>
                                </TextM>
                            </View>

                            {engagementAlerts.length > 0 && (
                                <ParentEngagementAlerts alerts={engagementAlerts} />
                            )}
                            {showEngagementOk && <ParentEngagementOk />}

                            <EngagementScoreBar
                                scores={report?.statistics?.scores}
                                width={scoreCardContentWidth}
                                forceVerticalDetails={forceVerticalDetails}
                                alertSeverityByScoreKey={alertSeverityByScoreKey}
                                showDetailHint={isEngagementReport}
                            />
                        </View>
                    </>
                )}

                {chapters?.length > 0 &&
                    !isV1Report &&
                    !!report?.statistics && (
                        <ChaptersWidgets
                            chapters={chapters}
                            linkedAssessments={report?.linked_assessments}
                            dimensions={dimensions}
                            boxStyle={boxStyle}
                        />
                    )}
                {isV1Report && !!report?.statistics && (
                    <>
                        <View
                            style={{
                                ...boxStyle,
                            }}
                        >
                            <TextM
                                fontSize={18}
                                fontWeight={"Bold"}
                                style={{ textAlign: "center" }}
                                wrap
                            >
                                TEMPS CONNECTÉ.E AU LIVE
                            </TextM>
                            <View
                                style={{
                                    flexDirection: "row",
                                    alignItems: "center",
                                    marginTop: 10,
                                }}
                            >
                                <IconImageM
                                    source={liveIcon}
                                    width={50}
                                    style={{ marginRight: 10 }}
                                />
                                <TextM fontSize={30} fontWeight={"ExtraBold"}>
                                    {formatHoursMinutesAndSeconds(
                                        report?.statistics
                                            ?.live_connection_duration
                                    )}
                                </TextM>
                            </View>
                        </View>
                        <View
                            style={{
                                ...boxStyle,
                            }}
                        >
                            <TextM
                                fontSize={18}
                                fontWeight={"Bold"}
                                style={{ textAlign: "center" }}
                                wrap
                            >
                                TEMPS D&apos;EXPLICATION
                            </TextM>
                            <View
                                style={{
                                    flexDirection: "row",
                                    alignItems: "center",
                                    marginTop: 10,
                                }}
                            >
                                <IconImageM
                                    source={videoIcon}
                                    width={50}
                                    style={{ marginRight: 10 }}
                                />
                                <TextM fontSize={30} fontWeight={"ExtraBold"}>
                                    {formatHoursMinutesAndSeconds(
                                        report?.statistics?.tutor_call_duration
                                    )}
                                </TextM>
                            </View>
                        </View>
                        <View
                            style={{
                                ...boxStyle,
                            }}
                        >
                            <TextM
                                fontSize={18}
                                fontWeight={"Bold"}
                                style={{ textAlign: "center" }}
                                wrap
                            >
                                TEMPS DE PRODUCTION CHRONOMÉTRÉ
                            </TextM>
                            <View
                                style={{
                                    flexDirection: "row",
                                    alignItems: "center",
                                    marginTop: 10,
                                }}
                            >
                                <IconImageM
                                    source={chronometer}
                                    width={50}
                                    style={{ marginRight: 10 }}
                                />
                                <TextM fontSize={30} fontWeight={"ExtraBold"}>
                                    {formatHoursMinutesAndSeconds(
                                        report?.statistics?.duration
                                    )}
                                </TextM>
                            </View>
                        </View>
                    </>
                )}

                {validatedActivities?.length + todoActivities?.length > 0 &&
                    !!report?.statistics && (
                        <View
                            style={{
                                ...boxStyle,
                            }}
                        >
                            {validatedActivities?.length > 0 && (
                                <>
                                    <TextM
                                        fontSize={18}
                                        fontWeight={"Bold"}
                                        wrap
                                    >
                                        TRAVAIL VALIDÉ ✅
                                    </TextM>
                                    {validatedActivities?.map((v, index) => (
                                        <LiveReportActivityItem
                                            key={index}
                                            report={report}
                                            data={v}
                                        />
                                    ))}
                                </>
                            )}

                            {validatedActivities?.length > 0 &&
                                todoActivities?.length > 0 && (
                                    <Divider
                                        style={{
                                            width: dimensions?.width - 60,
                                            marginVertical: 20,
                                            borderWidth: 1,
                                            borderColor: theme.colors.lightMore,
                                        }}
                                    />
                                )}

                            {todoActivities?.length > 0 && (
                                <>
                                    <TextM
                                        fontSize={18}
                                        fontWeight={"Bold"}
                                        wrap
                                    >
                                        TRAVAIL À FAIRE 📋
                                    </TextM>
                                    {todoActivities?.map((todo, index) => (
                                        <LiveReportActivityItem
                                            key={index}
                                            report={report}
                                            data={todo}
                                        />
                                    ))}
                                </>
                            )}
                        </View>
                    )}

                {!!report?.statistics?.CTAS?.sam && (
                    <>
                        <ChampionImageM
                            style={{
                                alignSelf: "center",
                                marginTop: 40,
                                marginBottom: 20,
                            }}
                            name="sam"
                            variant={"happy"}
                            width={100}
                        />
                        <TextM
                            color={theme.colors.primary}
                            fontSize={18}
                            fontWeight={"Bold"}
                            style={{ textAlign: "center", marginBottom: 10 }}
                            wrap
                        >
                            {report?.statistics?.CTAS?.sam}
                        </TextM>

                        <FilledButtonM
                            label={"Je prends rdv avec mon conseiller"}
                            color={theme.colors.success}
                            style={{
                                width: dimensions.width - 60,
                                alignSelf: "center",
                                marginTop: 15,
                                marginBottom: 15,
                            }}
                            onPress={() => openCalendly(report?.student)}
                        />
                    </>
                )}
            </View>
        </>
    )
}
const mapStateToProps = (state) => {
    return {
        getLiveReportRequest: state.api.getLiveReport?.request,
        getLiveReportError: state.api.getLiveReport?.error,
        user: state.data.currentUser?.object,
    }
}

const mapDispatchToProps = {
    apiRequest,
    apiIdle,
    setOngoingActivity,
    setIsLiveModeEnabled,
}

export default connect(mapStateToProps, mapDispatchToProps)(LiveReportComponent)
